import { ICompareState } from "./types";
import { IProduct } from "../../../entities/product/types";
import ActionTypes from "../../../constants/ActionTypes";
import _ from "lodash";

const initialState: ICompareState = {
  selectedProducts: [],
  productsDataForCompare: [],
  compareDashboardVisibility: false,
  showDiffs: false,
  productType: ''
};

const compareProductReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.COMPARE.SET_PRODUCT:
    let unMutedState = { ...state };
    if (action.payload.productType !== state.productType) {
      unMutedState = { ...state, selectedProducts: [] };
    }
    return {
      ...unMutedState,
      selectedProducts: _.concat(unMutedState.selectedProducts, action.payload.selectedProducts),
      productType: action.payload.productType
    };
  case ActionTypes.COMPARE.REMOVE_PRODUCT:
    const sliced = [...state.selectedProducts];
    const index = sliced.indexOf(action.payload);
    sliced.splice(index, 1);
    return {
      ...state,
      selectedProducts: sliced,
      productsDataForCompare: state.productsDataForCompare.filter((product: IProduct) => product.id !== action.payload)
    };
  case ActionTypes.COMPARE.DESELECT_ALL:
    return {
      ...state,
      selectedProducts: [],
      productsDataForCompare: []
    };
  case ActionTypes.COMPARE.TOGGLE_COMPARE_SHOW_DIFFS:
    return {
      ...state,
      showDiffs: action.payload
    };
  case ActionTypes.COMPARE.TOGGLE_COMPARE_DASHBOARD:
    if (action.payload === false) {
      const normalizedArrayOfSelectedProducts = state.selectedProducts.filter((productHolder: number | null) => productHolder);
      return {
        ...state,
        compareDashboardVisibility: action.payload,
        selectedProducts: normalizedArrayOfSelectedProducts
      };
    }
    return {
      ...state,
      compareDashboardVisibility: action.payload
    };
  case ActionTypes.COMPARE.NORMALIZE_COMPARE_PRODUCTS:
    const normalizedArrayOfSelectedProducts = state.selectedProducts.filter((productHolder: number | null) => productHolder);
    return {
      ...state,
      selectedProducts: normalizedArrayOfSelectedProducts
    };
  case ActionTypes.COMPARE.COMPARE_PRODUCT_SWITCH:
    const switchedIds = [...state.selectedProducts];
    switchedIds[action.payload.orderNumber] = action.payload.productId;

    return {
      ...state,
      selectedProducts: switchedIds
    };
  case ActionTypes.COMPARE.SET_COMPARE_DATA:
    return {
      ...state,
      productsDataForCompare: [...state.productsDataForCompare, action.payload]
    };
  }
  return state;
};

export default compareProductReducer;
